import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { SignupModal } from './SignupModal';
export function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      {/* Top Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-gaming-dark/80 backdrop-blur-md border-b border-white/5" data-id="element-87">
        <div className="container mx-auto px-4 py-4 flex items-center gap-3 max-w-7xl" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/3kBgnD6e6XdAgLnALwYUbB/levelup_logo_negativo.png" alt="LevelUp Play" className="h-10 object-contain" data-id="element-89" />
        </div>
      </nav>

      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-10 px-4" data-id="element-90">
        {/* Background Elements */}
        <div className="absolute inset-0 z-0" data-id="element-91">
          <div className="absolute inset-0 bg-gaming-dark opacity-90" data-id="element-92"></div>
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-93"></div>

          {/* Glowing Orbs */}
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-gaming-purple rounded-full mix-blend-screen filter blur-[100px] opacity-30 animate-pulse" data-id="element-94"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gaming-cyan rounded-full mix-blend-screen filter blur-[100px] opacity-20 animate-pulse" style={{
          animationDelay: '2s'
        }} data-id="element-95"></div>
        </div>

        <div className="container mx-auto z-10 relative max-w-6xl" data-id="element-96">
          <div className="flex flex-col items-center text-center" data-id="element-97">
            {/* Headline */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="text-4xl md:text-6xl lg:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white via-gaming-cyan to-gaming-purple mb-6 tracking-wider uppercase" data-id="element-98">
              Sube de Nivel <br className="hidden md:block" data-id="element-99" />
              <span className="text-white" data-id="element-100">Con Cada Partida</span>
            </motion.h1>

            {/* Subheading */}
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="text-gray-300 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed" data-id="element-101">
              Gana recompensas, participa en torneos y conecta con la comunidad
              gamer más grande del Ecuador. Tu pasión por los esports ahora
              tiene recompensa.
            </motion.p>

            {/* CTA Button */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} data-id="element-102">
              <button onClick={() => setIsModalOpen(true)} className="group relative px-8 py-4 bg-gaming-cyan text-gaming-dark font-bold text-lg rounded-sm overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(0,217,255,0.6)] uppercase tracking-widest clip-path-polygon" data-id="element-103">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-104">
                  Comenzar Ahora{' '}
                  <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-105" />
                </span>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity" data-id="element-106"></div>
              </button>
            </motion.div>

            {/* Scroll Indicator */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1.5,
            duration: 1
          }} className="absolute bottom-[-100px] left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block" data-id="element-107">
              <div className="w-6 h-10 border-2 border-gaming-cyan/50 rounded-full flex justify-center p-1" data-id="element-108">
                <div className="w-1 h-2 bg-gaming-cyan rounded-full animate-scroll" data-id="element-109"></div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Decorative Grid Floor */}
        <div className="absolute bottom-0 w-full h-1/3 bg-gradient-to-t from-gaming-cyan/10 to-transparent transform perspective-3d rotate-x-60 origin-bottom pointer-events-none" data-id="element-110"></div>

        {/* Signup Modal */}
        <SignupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-111" />
      </section>
    </>;
}